<ng-template #createConversationModal let-modal>
  <div class="modal-content">
    <div class="modal-header p-3">
      <h4 class="card-title mb-0">Create New Conversation</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="createForm" (ngSubmit)="onSubmit()">
        <div class="mb-3">
          <label for="name" class="form-label">Conversation Name <span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="name" placeholder="Enter conversation name" required formControlName="name" [ngClass]="{ 'is-invalid': submitted && f['name'].errors }">
          <div class="invalid-feedback"> Please enter conversation name </div>
        </div>
        <div class="mb-3">
          <div class="row">
            <div class="col-6">
              <label for="first_name" class="form-label">Subject First name <span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="first_name" placeholder="Enter first name" required formControlName="first_name" [ngClass]="{ 'is-invalid': submitted && f['first_name'].errors }">
              <div class="invalid-feedback"> Please enter first name </div>
            </div>
            <div class="col-6">
              <label for="last_name" class="form-label">Subject Last name <span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="last_name" placeholder="Enter last name" required formControlName="last_name" [ngClass]="{ 'is-invalid': submitted && f['last_name'].errors }">
              <div class="invalid-feedback"> Please enter last name </div>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label for="email" class="form-label">Email <span class="text-danger">*</span></label>
          <input type="email" class="form-control" id="email" placeholder="Enter email address" required formControlName="email" [ngClass]="{ 'is-invalid': submitted && f['email'].errors }">
          <div class="invalid-feedback"> Please enter email </div>
        </div>
        <div class="mb-3">
          <label for="gov_id" class="form-label">ID <span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="gov_id" placeholder="Enter ID" required formControlName="gov_id" [ngClass]="{ 'is-invalid': submitted && f['gov_id'].errors }">
          <div class="invalid-feedback"> Please enter ID </div>
        </div>
        <div class="mb-3">
          <label for="country" class="form-label">Country</label>
          <ng-select id="country" [items]="countriesList" bindLabel="countryName" bindValue="shortName" [searchable]="true" name="country" placeholder="Choose Country" formControlName="country">
            <ng-template ng-label-tmp let-item="item" let-search="searchTerm">
              <img height="20" width="20" src="{{ item.flagImg }}" alt="{{ item.countryName }}" />
              {{ item.countryName }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <img height="20" width="20" src="{{ item.flagImg }}" alt="{{ item.countryName }}" />
              {{ item.countryName }}
            </ng-template>
          </ng-select>
        </div>
        <div class="mb-3 form-check">
          <input type="checkbox" class="form-check-input" id="delete_video" formControlName="delete_video">
          <label class="form-check-label" for="delete_video">Delete video from storage after analysis
            <i class="ri-information-line align-bottom"
              ngbTooltip="Optional: Recommended for strict data privacy compliance (e.g., GDPR). If checked, the raw video will be deleted immediately after analysis. You will still view all graphs and data on the timeline, but the video player itself will be unavailable."
              placement="top">
            </i>
          </label>
        </div>
        <div class="text-end">
          <button type="submit" class="btn btn-primary btn-load">
            <span class="d-flex justify-content-center">
              @if (submitted && spinner) {
                <span class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
              }
              <span [ngClass]="submitted && spinner ? 'ms-2' : ''"> Create </span>
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #successModal let-modal>
  <div class="modal-content">
    <div class="modal-body text-center p-5">
      <div class="text-end">
        <button class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="mt-2">
        @if (success) {
          <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
        }
        @if (!success) {
          <lord-icon src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f06548,secondary:#f7b84b" style="width:120px;height:120px"></lord-icon>
        }
        <h4 class="mb-3 mt-4">{{ success ? 'Create Success.' : 'Create Error!'}}</h4>
        <p class="text-muted mx-4 mb-0">{{ message }}</p>
      </div>
    </div>
  </div>
</ng-template>